import { render } from "./modalFollowing.vue?vue&type=template&id=b673a0d2&scoped=true"
import script from "./modalFollowing.vue?vue&type=script&lang=js"
export * from "./modalFollowing.vue?vue&type=script&lang=js"

import "./modalFollowing.vue?vue&type=style&index=0&id=b673a0d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b673a0d2"]])

export default __exports__